<template>
  <div class="fts-variable-assignment-display fts-scrollbar">
    <div
      class="variable-assignment"
      v-for="field in fields"
      :key="field.id"
    >
      <div class="variable-assignment-field">
        <fts-automation-label
          :label-name="field.displayName"
          :label-type="field.icon"
          tooltip
          class="variable-assignment-field__label"
        />
        <div class="variable-assignment-field__value">
          <fts-formula-display
            v-model="field.value"
            :variables="variables"
            tooltip
            no-wrap
          />
        </div>
      </div>
      <!-- <div class="variable-assignment-debug">
        dummy data.
      </div> -->
    </div>
  </div>
</template>

<script>
import FTSFormulaDisplay from "../FTSFormulaDisplay.vue";
import FTSAutomationLabel from "./FTSAutomationLabel.vue";

export default {
  props: {
    moduleId: String,
    action: Object,
    variables: Array,
  },
  data: () => ({
    module: null,
  }),
  components: {
    "fts-automation-label": FTSAutomationLabel,
    "fts-formula-display": FTSFormulaDisplay,
  },
  computed: {
    fields() {
      if (
        this.action && Array.isArray(this.action.fields) &&
        this.module && Array.isArray(this.module.information)
      ) {
        let assignFields = _.cloneDeep(this.action.fields).map((x) => {
          let information = this.module.information.find(
            (y) => y.fieldName == x.key
          );

          if (!information) {
            if (this.action.informationId) {
              let table = this.module.information.find(
                (y) => y.id == this.action.informationId
              );
              information = table.fields.find((y) => y.fieldName == x.key);
            }
          }

          return {
            ...x,
            displayName: information.displayName, // set display name
            icon: information.type, // set icon type
          };
        });

        return assignFields;
      }
    },
  },
  async mounted() {
    let vm = this;
    if (vm.moduleId) {
      let data = await this.$store.dispatch("findVariable", {
        moduleId: vm.moduleId,
      });

      vm.module = data;
    }
  },
};
</script>

<style lang="scss" scoped>
.fts-variable-assignment-display {
  max-height: 150px;
  .variable-assignment {
    display: flex;
    margin-bottom: .575rem;
    .variable-assignment-field {
      min-width: 0;
      flex: 1;
      .variable-assignment-field__label {
        font-size: .875rem
      }
      .variable-assignment-field__value {
        max-width: 100%;
        display: inline-block;
        vertical-align: top;
        font-size: .75rem;
      }
    }
    .variable-assignment-debug {
      margin-left: 1rem;
      font-size: .875rem;
    }
  }
}
</style>